'use client'
import { tw } from '@/lib/utils'

import type { LauncherPanelProps } from './launcher-panel'
import styles from './launcher-styles'

import { SheetCardGrid } from '../sheet/sheet-card-grid'
import { SheetSearchInput } from '../sheet/sheet-search-input'

// Search mode (the bar's magnifier): a full-width focused field over the
// search menu's quick links until a query brings live results.
export const LauncherSearch = ({ container, query, inputRef, Results }: LauncherPanelProps) => (
  <>
    <SheetSearchInput
      term={query.searchTerm}
      onChange={query.setSearchTerm}
      onClear={query.reset}
      searching={query.searching}
      autoFocus={false}
      inputRef={inputRef}
      className="pt-2 pb-5"
    />
    <div
      key={query.results ? 'results' : 'start'}
      className={tw('-mx-2 min-h-0 flex-1 overflow-y-auto overscroll-contain px-2 pb-2', styles.rowsIn, styles.scroll)}
    >
      {Results ? (
        <Results container={container} query={query} />
      ) : (
        <SheetCardGrid items={[]} renderItem={() => null} loading={4} />
      )}
    </div>
  </>
)
